import { RegistrationAccessState } from "@pathwright/graphql-client/src/generated"
import type { RegistrationAccessRow } from "../../registration/access"

type LearnRegistration = {
  id: number
  path?: { progress?: number | null } | null
  group: { status?: string | null }
}

type AccessState = RegistrationAccessState | "unknown"
type AccessById = ReadonlyMap<
  number,
  Pick<RegistrationAccessRow, "access_state">
>

const priority: Record<AccessState, number> = {
  [RegistrationAccessState.Active]: 0,
  unknown: 1,
  [RegistrationAccessState.SubscriptionExpired]: 2,
  [RegistrationAccessState.Expired]: 3,
  [RegistrationAccessState.Archived]: 3
}

/** Access controls presentation; progress and cohort status control completion. */
export function getLearnRegistrationPresentation(
  registration: LearnRegistration,
  accessById: AccessById,
  parent?: LearnRegistration
) {
  let accessState: AccessState =
    accessById.get(registration.id)?.access_state ?? "unknown"
  if (parent) {
    const parentState = accessById.get(parent.id)?.access_state ?? "unknown"
    if (priority[parentState] > priority[accessState]) accessState = parentState
  }
  const isExpired =
    accessState !== "unknown" && accessState !== RegistrationAccessState.Active
  const isComplete =
    (registration.path?.progress ?? 0) >= 1 ||
    registration.group.status === "completed"
  return {
    accessState,
    isExpired,
    isComplete,
    canAccess:
      accessState !== RegistrationAccessState.Expired &&
      accessState !== RegistrationAccessState.Archived,
    isInCompletedSection: isComplete || isExpired
  }
}
